export default "$ yarn add sass sass-loader fibers deepmerge -D\n// OR\n$ npm install sass sass-loader fibers deepmerge -D\n";